import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ACTIONS_MENU_GROUP_IDS } from './useTrackAgentActionsMenuGroupOpened.meta';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

const META: Meta = {
  description: 'The user picks a task in the composer Actions menu, which inserts its prompt into the composer',
  name: 'agent_actions_menu_task_selected',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The task identifier (for example animate or resize-for-socials)',
      name: 'task_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The task group, named after its menu label: edit_in_bulk, organize_in_bulk, or ask_and_explore',
      name: 'group_id',
      required: true,
      type: 'enum',
      values: [...WORKSPACE_AGENT_ACTIONS_MENU_GROUP_IDS],
    },
    {
      description: 'Whether the task was picked from search results rather than by browsing a group',
      name: 'via_search',
      required: true,
      type: 'boolean',
    },
  ],
};

export default META;
